// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"5edc4c7e","281":"4758749e","327":"f7f57acd","639":"f7f57acd","756":"624a7d57","924":"72cdf397"}[chunkId] + ".chunk.css";
};